import { FC } from "react";
import ShareSiteSpeciesFilter from "./filters/ShareSiteSpeciesFilter";
import ShareSiteTypeOfFilters from "./filters/ShareSiteTypeOfFilter";
import {
  FetchingSharingStatusData,
  ListOfSpeciesData,
  ListTypeOfData,
  StoragesData,
} from "../../../../redux/slices/shareSite/shareSiteTypes";
import { useTranslation } from "react-i18next";
import { StoragesValuesView } from "../../../../redux/slices/grainTracker/grainTrackerTypes";
import ShareSiteButtonSelectAll from "./filters/ShareSiteSelectAll";
import ShareSiteButtonUnselectAll from "./filters/ShareSiteUnselectAll";
import ShareSiteSortStorage from "./filters/ShareSiteSortStorage";

type ShareSiteFiltersParams = {
  setSelectSpecieFilter: (value: number) => void;
  selectedSpecie: number;
  listOfSpeciesFilter: ListOfSpeciesData[];
  listOfSpeciesLoading: boolean;

  setSelectTypeOfFilter: (value: string) => void;
  typeSelected: string;
  listTypeOfFilter: ListTypeOfData[];
  listTypeOfLoading: boolean;

  setSelectedStoragesIds: (values: string[]) => void;
  storages: StoragesValuesView[];
  storagesLoading: boolean;

  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;
  setToDelete: (values: string[]) => void;
  sharingStatus: FetchingSharingStatusData;
  selectedStoragesIds: string[];

  setStorages: (values: StoragesData) => void;
  setSelectedSort: (values: string) => void;
  storagesData: StoragesData;
  selectedSort: string;
};

const ShareSiteFilters: FC<ShareSiteFiltersParams> = ({
  setSelectSpecieFilter,
  selectedSpecie,
  listOfSpeciesFilter,
  listOfSpeciesLoading,

  setSelectTypeOfFilter,
  typeSelected,
  listTypeOfFilter,
  listTypeOfLoading,

  setSelectedStoragesIds,
  storages,
  storagesLoading,

  storageSharedDeleteLoading,
  storageSharingLoading,
  setToDelete,
  sharingStatus,
  selectedStoragesIds,

  setStorages,
  setSelectedSort,
  storagesData,
  selectedSort,
}) => {
  const [t] = useTranslation("global");

  return (
    <div className="share-site-first-card">
      <div className="share-site-subtitle">{t("Share_site.question-text")}</div>
      <div className="share-site-filters-container">
        <ShareSiteSpeciesFilter
          setSelectSpecieFilter={setSelectSpecieFilter}
          selectedSpecie={selectedSpecie}
          listOfSpeciesFilter={listOfSpeciesFilter}
          listOfSpeciesLoading={listOfSpeciesLoading}
          storagesLoading={storagesLoading}
          storageSharedDeleteLoading={storageSharedDeleteLoading}
          storageSharingLoading={storageSharingLoading}
        />
        <ShareSiteTypeOfFilters
          setSelectTypeOfFilter={setSelectTypeOfFilter}
          typeSelected={typeSelected}
          listTypeOfFilter={listTypeOfFilter}
          listTypeOfLoading={listTypeOfLoading}
          storagesLoading={storagesLoading}
          storageSharedDeleteLoading={storageSharedDeleteLoading}
          storageSharingLoading={storageSharingLoading}
        />
        <ShareSiteButtonSelectAll
          setSelectedStoragesIds={setSelectedStoragesIds}
          storages={storages}
          storageSharedDeleteLoading={storageSharedDeleteLoading}
          storageSharingLoading={storageSharingLoading}
          storagesLoading={storagesLoading}
          setToDelete={setToDelete}
          sharingStatus={sharingStatus}
        />

        <ShareSiteButtonUnselectAll
          setSelectedStoragesIds={setSelectedStoragesIds}
          storageSharedDeleteLoading={storageSharedDeleteLoading}
          storageSharingLoading={storageSharingLoading}
          storagesLoading={storagesLoading}
          setToDelete={setToDelete}
          selectedStoragesIds={selectedStoragesIds}
          sharingStatus={sharingStatus}
          storages={storages}
        />

        <ShareSiteSortStorage
          setStorages={setStorages}
          setSelectedSort={setSelectedSort}
          storages={storagesData}
          selectedSort={selectedSort}
        />
      </div>
    </div>
  );
};

export default ShareSiteFilters;
